import { Capacitor } from '@capacitor/core';
import { Haptics } from '@capacitor/haptics';
import { NativeAudio } from '@capgo/native-audio';

export const newChatNotify = () => {
  if (Capacitor.isPluginAvailable('NativeAudio')) NativeAudio.play({ assetId: 'newChatSound' });
  if (Capacitor.isPluginAvailable('Haptics')) Haptics.vibrate();
};

export const newAlertNotify = () => {
  if (Capacitor.isPluginAvailable('NativeAudio')) NativeAudio.play({ assetId: 'newAlertSound' });
  if (Capacitor.isPluginAvailable('Haptics')) Haptics.vibrate();
};
